require('./userFeedController');

'use strict';

angular.module('app.shared.userFeed.userFeedDirective', [
    'app.shared.userFeed.userFeedController',
    'app.shared.userPhoto.userPhotoDirective'
])
    .directive('userFeed', [
        function () {
            return {
                restrict: 'EA',
                templateUrl: 'components/shared/userFeed/userFeedView.html',
                controller: 'app.shared.userFeed.userFeedController',
                scope: {
                    userId: '<',
                    feedType: '<',
                    limitFavorites: '<',
                    hideControls: '<',
                    strictFeed: '<',
                    notEditable: '<',
                    noFeedText: '@'
                }
            };
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/userFeed/userFeedDirective.js